import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags() {
  return {
    title: `${config.valuePlan.text} | SPOOX(スプークス)`,
    keywords: `${config.valuePlan.text},SPOOX,スプークス,動画配信,スカパー！`,
    description: `SPOOX(スプークス)では、${config.valuePlan.text}の動画を配信中です。`,
    og: { type: "article", url: `${config.host.vod}${routes.valuePlan}` },
  };
}

export default function ValuePlanPageMetaTags() {
  const metatags = tags();
  return <MetaTags {...metatags} />;
}
